import React, { useEffect, useState } from "react";

const Preloader = ({ children }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Hide preloader after 3 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div id="preloader">
        <div className="plod">
          <span className="lod1">
            <img src="/images/loder/1.png" loading="lazy" alt="Loader 1" />
          </span>
          <span className="lod2">
            <img src="/images/loder/2.png" loading="lazy" alt="Loader 2" />
          </span>
          <span className="lod3">
            <img src="/images/loder/3.png" loading="lazy" alt="Loader 3" />
          </span>
        </div>
      </div>
    );
  }

  // After loading is done, render whatever you passed inside <Preloader>...</Preloader>
  return <>{children}</>;
};

export default Preloader;
